import React from 'react';
import { FileText } from 'lucide-react';

const TermsConditions = () => {
  return (
    <section id="terms" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <FileText className="text-[#C5A572]" size={40} />
            <h2 className="text-4xl md:text-5xl font-bold text-[#8B9E8A]">
              Conditions Générales
            </h2>
          </div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Modalités et conditions d'intervention
          </p>
        </div>

        {/* Terms Content */}
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 md:p-12 border border-[#C5A572]/20">
          <div className="space-y-6 text-gray-700 leading-relaxed">
            
            <div>
              <h3 className="text-2xl font-bold text-[#8B9E8A] mb-4">1. Domaine d'intervention</h3>
              <p>
                Gratia Animalis intervient exclusivement sur des animaux en bonne santé. Je n'accepte pas les animaux malades nécessitant des soins vétérinaires, à l'exception des maladies chroniques pour lesquelles une prise en charge peut être envisagée après validation. En cas de doute sur l'état de santé de votre animal, veuillez consulter votre vétérinaire avant de prendre rendez-vous.
              </p>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-[#8B9E8A] mb-4">2. Prise de rendez-vous</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Les rendez-vous se prennent par téléphone, SMS ou via le formulaire en ligne</li>
                <li>Un rendez-vous n'est confirmé qu'après validation de ma part</li>
                <li>Je me réserve le droit de refuser une prestation sans avoir à me justifier</li>
              </ul>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-[#8B9E8A] mb-4">3. Annulation et report</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Merci de me prévenir au plus tôt en cas d'annulation</li>
                <li>Un report est possible sous réserve de disponibilité</li>
              </ul>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-[#8B9E8A] mb-4">4. Tarifs et paiement</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Les tarifs affichés sont TTC</li>
                <li>Le paiement s'effectue le jour de la prestation</li>
                <li>Moyens de paiement acceptés : espèces, carte bancaire, chèque, virement bancaire</li>
                <li>Les frais de déplacement sont à ajouter selon la distance</li>
              </ul>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-[#8B9E8A] mb-4">5. Forfaits</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Les forfaits sont valables <strong>12 mois</strong> à compter de la date d'achat</li>
                <li>Les séances du forfait ne sont ni remboursables ni échangeables</li>
                <li>En cas de non-utilisation dans les délais, le forfait est perdu</li>
              </ul>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-[#8B9E8A] mb-4">6. Conditions d'intervention</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>L'animal doit être propre pour permettre une bonne prise en charge</li>
                <li>Le propriétaire doit être présent lors de toutes les prises en charge</li>
                <li>Un espace adapté et sécurisé doit être mis à disposition</li>
                <li>Je me réserve le droit d'interrompre une séance si l'animal présente un comportement dangereux</li>
              </ul>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-[#8B9E8A] mb-4">7. Responsabilité</h3>
              <p>
                Le massage animalier est une pratique de bien-être et ne se substitue en aucun cas à un suivi vétérinaire. Je ne suis pas responsable des accidents ou blessures qui pourraient survenir pendant ou après la séance, sauf en cas de faute professionnelle avérée.
              </p>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-[#8B9E8A] mb-4">8. Données personnelles</h3>
              <p>
                Les informations recueillies lors de la prise de rendez-vous sont nécessaires à la gestion de votre dossier. Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour exercer ce droit, contactez-moi par email ou téléphone.
              </p>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-[#8B9E8A] mb-4">9. Litiges</h3>
              <p>
                En cas de litige, une solution amiable sera toujours recherchée en priorité. À défaut, les tribunaux compétents de Bordeaux seront seuls compétents.
              </p>
            </div>

            <div className="mt-8 pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-500 italic">
                Dernière mise à jour : Janvier 2026
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TermsConditions;
